// extracted by mini-css-extract-plugin
export default {"container":"OrganizationResourcesFeed__container___mASL4","feedContainer":"OrganizationResourcesFeed__feedContainer___fJ2HA"};